/**
 * @description
 * Icon is usually only visual representation and therefore is hidden from screen readers.
 *
 * @specification
 * Adds attribute 'aria-hidden=true' to icon.
 */
var iconBehavior = function (props) { return ({
    attributes: {
        root: {
            'aria-hidden': 'true',
        },
    },
}); };
export default iconBehavior;
